if (!window.Eurus.loadedScript.has('free-gift.js')) {
  window.Eurus.loadedScript.add('free-gift.js');

  // Re-render cart drawer + related sections from a parsed cart response.
  function rerenderCartSections(parsedState) {
    if (!Alpine.store('xCartHelper')) return;
    const sections = Alpine.store('xCartHelper').getSectionsToRender();
    sections.forEach((section) => {
      const sectionElement = document.querySelector(section.selector);
      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      const html = parsedState.sections[section.id];
      // For cart-drawer, only swap items + footer to preserve drawer chrome.
      if (section.id === 'cart-drawer') {
        const itemsSel = section.selector + ' .cart-drawer-items';
        const footerSel = section.selector + ' .cart-drawer-footer';
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (parsed.querySelector(itemsSel) && parsed.querySelector(footerSel)) {
          document.querySelector(itemsSel).innerHTML =
            parsed.querySelector(itemsSel).innerHTML;
          document.querySelector(footerSel).innerHTML =
            parsed.querySelector(footerSel).innerHTML;
          return;
        }
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fragment = parsed.querySelector(section.selector);
      if (fragment) sectionElement.innerHTML = fragment.innerHTML;
    });

    if (parsedState.item_count !== undefined) {
      const prev = Alpine.store('xCartHelper').currentItemCount;
      Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
      if (prev !== parsedState.item_count) {
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      }
    }
  }

  function getSectionIds() {
    if (!Alpine.store('xCartHelper')) return [];
    return Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id);
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFreeGift', () => ({
        loading: false,
        _autoRemoving: false,

        init() {
          // If liquid says: gift is in cart but threshold no longer met, remove it.
          this.$nextTick(() => this._maybeAutoRemove());
        },

        _maybeAutoRemove() {
          if (this._autoRemoving) return;
          const raw = this.$el.dataset.autoRemove;
          if (!raw) return;
          const keys = raw.split(',').map((k) => k.trim()).filter(Boolean);
          if (!keys.length) return;
          this._autoRemoving = true;
          this._removeKeys(keys).finally(() => {
            this._autoRemoving = false;
          });
        },

        async _removeKeys(keys) {
          if (!keys.length) return;
          this.loading = true;
          const updates = {};
          keys.forEach((k) => { updates[k] = 0; });
          try {
            const res = await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                updates,
                sections: getSectionIds(),
                sections_url: window.location.pathname,
              }),
            });
            const data = await res.json();
            rerenderCartSections(data);
          } catch (err) {
            console.error('[free-gift] remove failed', err);
          } finally {
            this.loading = false;
          }
        },

        async addGift(variantId) {
          if (this.loading) return;
          // Liquid is the source of truth. These guards prevent stale drawer
          // interactions while a cart section is being replaced.
          const qualificationType = this.$el.dataset.qualificationType || 'spending_threshold';
          if (qualificationType === 'qualifying_items') {
            const requiredQuantity = parseInt(this.$el.dataset.requiredQuantity || '1', 10);
            const qualifyingQuantity = parseInt(this.$el.dataset.qualifyingQuantity || '0', 10);
            if (qualifyingQuantity < requiredQuantity) return;
          } else {
            const thresholdCents = parseInt(this.$el.dataset.thresholdCents || '0', 10);
            const qualifyingCents = parseInt(this.$el.dataset.qualifyingCents || '0', 10);
            if (thresholdCents > 0 && qualifyingCents < thresholdCents) return;
          }

          this.loading = true;
          try {
            const code = this.$el.dataset.giftDiscountCode;
            if (code) {
              // Apply discount code via /discount/CODE so it's stored in the
              // session and applied at checkout. Fire-and-forget; errors here
              // shouldn't block adding the gift.
              fetch(`${Shopify.routes.root}discount/${encodeURIComponent(code)}`, {
                method: 'GET',
                credentials: 'same-origin',
              }).catch(() => {});
            }

            const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }],
                sections: getSectionIds(),
                sections_url: window.location.pathname,
              }),
            });
            const data = await res.json();
            if (data.status && data.status >= 400) {
              console.warn('[free-gift] add error', data);
              return;
            }
            rerenderCartSections(data);
            if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').openCart();
          } catch (err) {
            console.error('[free-gift] add failed', err);
          } finally {
            this.loading = false;
          }
        },
      }));
    });
  });
}
